import { type GetDataIngestionSourcesResponse } from '../../../types';

import { getNewerDatasets } from './get-newer-datasets';

export type BatchFreshnessStatus = 'batch_data_old' | 'batch_data_new';

/**
 * Determines whether a batch is stale by checking if any datasets
 * have been updated since the batch was created.
 */
export const getBatchFreshnessStatus = (
  datasets: GetDataIngestionSourcesResponse['sources'],
  batchCreatedAt?: string,
): BatchFreshnessStatus => {
  if (!batchCreatedAt) {
    return 'batch_data_new';
  }
  const newerDatasets = getNewerDatasets(datasets, batchCreatedAt);

  return newerDatasets && newerDatasets.length > 0
    ? 'batch_data_old'
    : 'batch_data_new';
};
